export const removeTags = (str: string): any => {
  if (str === null) return null;
  else {
    if (str === "") return "";
    else str = str.toString();
  }
  return str.replace(/(<([^>]+)>)/gi, "");
};
